module.exports = __webpack_public_path__ + "img/logo_square_money_match.66cd5ac6.png";